import React, { useContext, useEffect, useState } from 'react'
import { graphql } from 'gatsby'
import {
  StyledContainer,
  StyledRow,
  ImageCol,
  FormCol,
  ZoomPreview,
  HelpText,
} from './styles'
import { Helmet } from 'react-helmet'
import ProductForm from '~/components/ProductForm'
import Preview from '~/components/Preview'
import StoreContext from '~/context/StoreContext'

const ProductPage = ({
  data: {
    allShopifyProduct: { edges: products },
  },
}) => {
  const { resetFromQuerySting } = useContext(StoreContext)

  const actualProducts = products.filter(product =>
    product.node.tags.includes('style')
  )

  const [zoomOpen, setZoomOpen] = useState(false)

  useEffect(() => {
    resetFromQuerySting()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <script
          src="https://www.wheelofpopups.com/api/v4458/widget.js"
          type="text/javascript"
          defer="defer"
        ></script>
      </Helmet>
      <StyledContainer fluid>
        <StyledRow>
          <ImageCol
            id="ImageCol"
            onClick={() => setZoomOpen(prevState => !prevState)}
          >
            <Preview />
            {zoomOpen && (
              <ZoomPreview>
                <span></span>
                <Preview />
              </ZoomPreview>
            )}
            <HelpText>
              Tryk her for at se større forhåndsvisning af din plakat
            </HelpText>
          </ImageCol>
          <FormCol>
            <ProductForm products={actualProducts} />
          </FormCol>
        </StyledRow>
      </StyledContainer>
    </>
  )
}

export const query = graphql`
  query {
    allShopifyProduct {
      edges {
        node {
          id
          title
          handle
          productType
          description
          descriptionHtml
          shopifyId
          tags
          options {
            id
            name
            values
          }
          variants {
            id
            title
            price
            availableForSale
            shopifyId
            selectedOptions {
              name
              value
            }
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`

export default ProductPage
